import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/storage";

var firebaseConfig = {
    apiKey: "AIzaSyBao4nqajqZGEVklbKCP2AG-4CPxONuKVA",
    authDomain: "fadhlaouiengchat.firebaseapp.com",
    databaseURL: "https://fadhlaouiengchat.firebaseio.com",
    projectId: "fadhlaouiengchat",
    storageBucket: "fadhlaouiengchat.appspot.com",
    messagingSenderId: "438229971721",
    appId: "1:438229971721:web:d6397015d1198b2ccb19d8"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);


export default firebase